// src/components/insights/Quote.jsx

function Quote({ children }) {
  return <blockquote className="quote">{children}</blockquote>;
}

export default Quote;